import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente, usuarioPerfilExpedicao, usuarioPerfilGerente, usuarioPerfilRepresentante } from '../usuario/usuario-perfil';


/** Acessos permitidos a tela de coleta */
export const acessosColeta: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilRepresentante, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilExpedicao];

@Injectable()
export class CanActivateColeta implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosColeta);
    }
}
